import { useApp } from "@/context/AppContext";
import { useAuth } from "@/context/AuthContext";
import { CircleDollarSign, User, Shield, Building2, LogOut } from "lucide-react";

export default function Settings() {
  const { user, logout } = useAuth();
  const { currency, toggleCurrency, companies } = useApp();

  return (
    <div className="space-y-6 animate-fade-up max-w-2xl" data-testid="settings-page">
      <div>
        <h1 className="text-2xl md:text-3xl font-heading font-extrabold text-slate-900">Settings</h1>
        <p className="text-slate-500 text-sm mt-0.5">Manage your preferences</p>
      </div>

      <Section icon={User} title="Profile">
        <Row label="Name" value={user?.name} />
        <Row label="Email" value={user?.email} />
        <Row label="Role" value={user?.role === "super_admin" ? "Super Admin" : "User"} />
        <Row label="Sign-in method" value={user?.auth_provider === "google" ? "Google" : "Email & Password"} />
      </Section>

      <Section icon={CircleDollarSign} title="Display Currency">
        <p className="text-sm text-slate-500 mb-3">Choose how monetary values are displayed across the app.</p>
        <div className="flex gap-2">
          {["INR", "USD"].map((c) => (
            <button key={c} data-testid={`settings-currency-${c}`} onClick={() => toggleCurrency(c)}
              className={`px-5 py-2.5 rounded-xl font-semibold text-sm border ${currency === c ? "bg-indigo-600 text-white border-indigo-600" : "bg-white text-slate-600 border-slate-200"}`}>
              {c === "INR" ? "\u20B9 Indian Rupee" : "$ US Dollar"}
            </button>
          ))}
        </div>
      </Section>

      <Section icon={Building2} title="Workspaces">
        <p className="text-sm text-slate-600">You have access to <b>{companies.length}</b> {companies.length === 1 ? "company" : "companies"}.</p>
        <div className="flex flex-wrap gap-2 mt-2">
          {companies.map((c) => <span key={c.id} className="text-xs font-semibold px-3 py-1.5 rounded-lg bg-slate-100 text-slate-600">{c.name}</span>)}
        </div>
      </Section>

      <Section icon={Shield} title="Security">
        <button data-testid="settings-logout" onClick={logout}
          className="flex items-center gap-2 px-4 py-2.5 rounded-xl border border-rose-200 text-rose-600 font-semibold text-sm hover:bg-rose-50">
          <LogOut size={16} /> Sign out of all sessions
        </button>
      </Section>
    </div>
  );
}

function Section({ icon: Icon, title, children }) {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6">
      <div className="flex items-center gap-2 mb-4"><Icon size={18} className="text-indigo-600" /><h3 className="font-heading font-bold text-slate-800">{title}</h3></div>
      {children}
    </div>
  );
}
const Row = ({ label, value }) => (
  <div className="flex justify-between py-2 border-b border-slate-50 last:border-0">
    <span className="text-sm text-slate-500">{label}</span>
    <span className="text-sm font-semibold text-slate-800">{value}</span>
  </div>
);
